// 德语
export default {
  Login: {
    Title: "Melden Sie sich bei Ihrem Konto an",
    describe:
      "Bitte melden Sie sich an oder erstellen Sie ein Konto, um zu beginnen.",
    Google: "Mit Google fortfahren",
    Apple: "Mit Apple fortfahren",
    or: "ODER",
    Emailplaceholder: "E-Mail-Adresse",
    Passwordplaceholder: "Passwort",
    Login: "Anmelden",
    forgot: "Passwort vergessen?",
    notAccount: "Haben Sie noch kein Fineshare-Konto?",
    Signup: "Registrieren",
    InvalidEmail: "Ungültiges E-Mail-Format.",
    InvalidPassword: "Das Passwort sollte mindestens 6 Zeichen lang sein.",
    loading: "Lädt...",
    login: "Anmelden",
    errorText:
      "Anmeldung fehlgeschlagen, bitte überprüfen Sie Ihren Benutzernamen und Passwort",
  },
  signup: {
    Title: "Erstellen Sie Ihr Konto",
    describe: "Erstellen Sie in wenigen Sekunden Ihr Fineshare-Konto.",
    Google: "Mit Google registrieren",
    Apple: "Mit Apple registrieren",
    or: "ODER",
    Emailplaceholder: "E-Mail-Adresse eingeben",
    Passwordplaceholder: "Geben Sie ein 6-stelliges Passwort ein",
    Already: "Haben Sie bereits ein Konto?",
    Login: "Anmelden",
    By: "Durch die Erstellung eines Kontos stimme ich zu, dass ich die",
    Privacy: "Datenschutzrichtlinie",
    Terms: "Nutzungsbedingungen.",
    and: "und",
    signupText: "Erstellen Sie Ihr Konto",
    InvalidEmail: "Ungültiges E-Mail-Format.",
    InvalidPassword: "Das Passwort sollte mindestens 6 Zeichen lang sein.",
    loading: "Lädt...",
    passwordError: "Die E-Mail-Adresse wurde bereits registriert",
    again:
      "Sie stellen zu viele Anfragen, bitte versuchen Sie es später noch einmal",
    Registration:
      "Registrierung fehlgeschlagen, bitte überprüfen Sie Ihre E-Mail-Adresse und Passwort.",
    hasRegistered: "Die E-Mail-Adresse wurde bereits registriert",
    Title2: "Erstellen Sie Ihr Fineshare-Konto",
  },
  Home: {
    Welcome: "Willkommen im Fineshare-Kontozentrum",
    Hi: "Hallo,",
    Order: "Meine Bestellungen",
    orders: "Sehen Sie unsere Kaufbestellungen an",
    Learn: "Mehr erfahren",
    Product: "Produkte verwalten",
    products: "Sehen Sie meine gekauften Produkte an",
    Setting: "Kontoeinstellungen",
    Settings: "Kontodetails und Passwort ändern",
    account: "Nutzen Sie Ihr Konto optimal",
    FineCam: "FineCam",
    FineCams: "Erstellen und teilen Sie Ihre inspirierenden Videos überall",
    FineVoice: "FineVoice",
    FineVoices:
      "Erstellen Sie Voiceovers mit Ihren Lieblingsstimmen, auf Ihre Weise",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "Verwandeln Sie Ihre Stimme, übertragen Sie Ihre Emotionen",
    Singify: "Singify",
    Singifys: "Erstellen Sie KI-Covers mit den Stimmen Ihrer Wahl",
  },
  success: {
    Congratulations: "Herzlichen Glückwunsch!",
    successfully: "Ihr Fineshare-Konto wurde erfolgreich erstellt.",
  },
  successapp: {
    Successful: "Erfolgreiche Anmeldung!",
    successfully1:
      "Sie haben sich erfolgreich in Ihr Fineshare-Konto eingeloggt und können nun die App verwenden.",
    successfully2:
      "Sie haben sich erfolgreich in Ihr Fineshare-Konto eingeloggt. Sie können dieses Fenster nun schließen und mit der App-Nutzung beginnen.",
    Go: "Zum Fineshare Benutzerzentrum",
  },
  forgot: {
    ForgotPas: "Passwort vergessen?",
    Enter1: "Geben Sie die E-Mail-Adresse zum Zurücksetzen des Passworts ein",
    Enter2:
      "Geben Sie Ihre E-Mail-Adresse ein, und wir senden Ihnen einen Link zum Zurücksetzen des Passworts.",
    exmple: "name@beispiel.com",
    Back: "Zurück zum Login",
    submitText: "Absenden",
    errorText: "Bitte geben Sie Ihre E-Mail-Adresse ein",
    loading: "wird geladen...",
    sent: "Wir haben eine E-Mail an Ihre Adresse gesendet",
    notExist: "Ihre E-Mail existiert nicht, bitte überprüfen Sie Ihre E-Mail",
    Reset: "Zurücksetzen fehlgeschlagen, bitte überprüfen Sie Ihre E-Mail",
  },
  account: {
    Settings: "Kontoeinstellungen",
    Change: "Ändern Sie Ihre Kontodaten, Passwörter und mehr.",
    Personal: "Persönliche Informationen",
    email: "E-Mail:",
    Name: "Benutzername:",
    Edit: "Bearbeiten",
    title: "Benutzernamen ändern",
    message: "Der eingegebene Name darf nicht leer sein.",
    placeholder: "Bitte geben Sie Ihren Benutzernamen ein",
    Reset: "Passwort zurücksetzen",
    Resets:
      "Sie können Ihr Passwort zurücksetzen, geben Sie 6 oder mehr Zahlen und Passwort ein",
    ResetPas: "Passwort zurücksetzen",
    Delete: "Konto löschen",
    Deletes:
      "Dadurch wird Ihr Konto und alle zugehörigen Daten dauerhaft gelöscht, und Sie können dieses Konto nicht reaktivieren.",
    sure: "Sind Sie sicher, dass Sie Ihr Fineshare-Konto löschen möchten?",
    sures:
      "Sobald Ihr Konto gelöscht wurde, werden alle Ihre Daten auf Fineshare dauerhaft entfernt. Um mit der Kontolöschung fortzufahren, haben wir Ihnen einen Bestätigungscode gesendet. Bitte geben Sie den Code ein und klicken Sie auf Bestätigen.",
    Deletebtn: "Löschen",
    Deleteplaceholder: "Bitte geben Sie den 6-stelligen Bestätigungscode ein",
  },
  order: {
    Order: "Meine Bestellungen",
    history: "Ihre Bestellhistorie wurde auf dieser Seite aufgezeichnet",
    dont: "Sie haben noch kein Produkt",
    Buy: "Kaufen Sie jetzt, um mehr Optimierungen zu erhalten, klicken Sie auf die Schaltfläche unten, um es jetzt zu erhalten",
    BuyBtn: "Jetzt kaufen",
    OrderId: "Bestell-ID:",
    Price: "Preis:",
    Date: "Bestelldatum:",
  },
  Product: {
    Product: "Mein Produkt",
    products: "Die Produkte in Ihrem Konto",
    dont: "Sie haben noch kein Produkt",
    Management: "Geräte verwalten >",
  },
  redeem: {
    Redeem: "Mitglied einlösen",
    products: "Hier können Sie Fineshare-Produkte einlösen",
    Please: "Bitte geben Sie Ihren Einlösecode ein",
    placeholder: "Einlösecode",
    Submit: "Absenden",
    Notes: "Hinweise:",
    Notes1: "1. Format des Einlösecodes: XXXXX;",
    Notes2:
      "2. Um Ihre eingelösten Produkte anzuzeigen, klicken Sie auf das Menü 'Produkt'.",
    Successfully: "Erfolgreich eingelöst",
    Follow:
      "Folgen Sie den untenstehenden Schritten, um VoiceTrans zu verwenden:",
    step1:
      "1. Laden Sie Fineshare VoiceTrans herunter und installieren Sie es.",
    step2: "2. Öffnen Sie VoiceTrans und gehen Sie zu ",
    Account: "Konto",
    step3:
      "3. Geben Sie Ihre E-Mail und Ihr Passwort ein, um sich in Ihrem Fineshare-Konto anzumelden.",
    Tips: "Tipp: Für eine bessere Nutzung lesen Sie bitte den ",
    guide: "Leitfaden",
    Redemption: "Einlösung fehlgeschlagen",
    redeemed:
      "Der Einlösecode wurde bereits eingelöst. Bitte öffnen Sie die Software und melden Sie sich erneut in Ihrem Konto an, um es zu verwenden.",
    Failed: "Einlösung fehlgeschlagen",
    check: "Bitte überprüfen Sie Ihren Einlösecode.",
  },
  details: {
    Product: "Mein Produkt",
    products: "Alle Produkte, die Sie gekauft haben, sind auf dieser Seite",
    Back: "Zurück zur Liste",
    Name: "Gerätename",
    system: "Gerätesystem",
    status: "Gerätestatus",
    Operation: "Aktion",
    Delete: "Löschen",
    contact:
      "Direktes Entfernen wird derzeit nicht unterstützt. Wenn Sie das Gerät entfernen möchten, kontaktieren Sie uns bitte unter ",
  },
  nav: {
    Home: "Startseite",
    Account: "Konto",
    Order: "Bestellung",
    Product: "Produkt",
    Redeem: "Einlösen",
    Help: "Hilfe-Center",
  },
  auth: {
    Authorization: "Autorisierung erfolgreich!",
    wait: "Wird zum Programm zurückgekehrt, bitte warten...",
  },
  notfound: {
    Not: "Seite nicht gefunden",
    Unfortunately:
      "Leider existiert die Seite, die Sie suchen, nicht oder es gibt einen Fehler im eingegebenen Link.",
    Home: "Zur Startseite gehen",
  },
  topuser: {
    Settings: "Kontoeinstellungen",
    language: "Sprache",
    Logout: "Abmelden",
  },
  loginweb: {
    Conversion: "Die Konvertierung wird bald beginnen",
    currently: "Derzeit sind ",
    people: " Personen in der Warteschlange!",
    Please:
      "Bitte melden Sie sich an, und wir senden Ihnen die Ergebnisse nach Abschluss der Konvertierung per E-Mail zu.",
    dont: "Ich möchte mich nicht anmelden",
  },
  mobilelogin: {
    Welcome:
      "Willkommen bei Fineshare! Bitte melden Sie sich an, um zu beginnen.",
  },
  reset: {
    Reset: "Setze ein neues Passwort zurück",
    Password:
      "Das Passwort muss mindestens 6 Zeichen enthalten, davon mindestens 1 Buchstaben und 1 Zahl.",
    password: "Geben Sie Ihr neues Passwort ein",
    Back: "Zurück zur Anmeldung",
    Congratulations: "Herzlichen Glückwunsch!",
    successfully:
      "Passwort erfolgreich zurückgesetzt, melden Sie sich sofort an",
    Login: "Anmelden",
    Please: "Bitte geben Sie 6 Ziffern und Buchstaben ein",
    failed:
      "Passwort zurücksetzen fehlgeschlagen, bitte klicken Sie auf den Zurücksetzungslink in Ihrem Posteingang",
  },
  verification: {
    verification: "Geben Sie den Bestätigungscode ein",
    haveverification: "Wir haben einen Bestätigungscode an ",
    Please:
      "gesendet. Bitte geben Sie den erhaltenen Bestätigungscode unten ein:",
    Enter: "Geben Sie den 6-stelligen Bestätigungscode ein",
    Resend: "Bestätigungscode erneut senden",
    Wait: "Warten Sie ",
    again: " Sekunden und senden Sie erneut",
    Verify: "Verifizieren",
    error: "Fehler im Bestätigungscode",
    verificationcode: "Bitte geben Sie den Bestätigungscode ein",
  },
};
